import { reactive, toRefs } from '@vue/composition-api'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'

export default () => {
  const state = reactive({
    token: storage.get(ACCESS_TOKEN),
  })

  return {
    ...toRefs(state)
  }
}
